<template>
    <div>
        <button class="focus:outline-none button__add_text" @click="addText">
            <span class="button__add_text_t">T</span>
            <span class="button__add_text_label">{{
                $t("client.engraving.add_text")
            }}</span>
        </button>

        <div
            class="mt-4"
            v-if="activeFace && activeFace.texts && activeFace.texts.length"
        >
            <div class="mb-4 text-sm">Перечень надписей стороны элемента</div>
            <ul class="flex flex-col gap-2">
                <li
                    v-for="(text, index) in activeFace.texts"
                    :key="`text-${text.text_id}`"
                    class="text__item"
                    :class="{
                        'text--border': index + 1 < activeFace.texts.length,
                    }"
                >
                    <span class="text__index_name">
                        <span class="text__index">{{ index + 1 }}.</span>
                        <span
                            class="text__name"
                            :style="{ fontFamily: text.font.name }"
                        >
                            {{ $knifeString(text.text, 40) }}
                        </span>
                    </span>
                    <span class="text__actions">
                        <button class="button-edit" @click="editingText = text">
                            <img
                                src="/images/icons/engraving-text/redaktirovat.svg"
                                alt=""
                            />
                        </button>
                        <button
                            class="button-delete"
                            @click="deletingText = text"
                        >
                            <img
                                src="/images/icons/engraving-text/udalit.svg"
                                alt=""
                            />
                        </button>
                    </span>
                </li>
            </ul>
        </div>
        <Modal v-if="deletingText" @close-modal="deletingText = null">
            <div class="font-bold mb-4">
                Вы действительно хотите удалить текст "{{ deletingText.text }}"?
            </div>
            <div>
                <button class="btn btn-small btn-red" @click="deleteText">
                    Да
                </button>
            </div>
        </Modal>
        <ClientModal v-if="editingText" @close-modal="editingText = null">
            <template #header>
                <div class="font-bold mb-4">Редактирование надписи</div>
            </template>

            <edit-text
                :editingText="editingText"
                @text-success-saved="editingText = null"
            />
        </ClientModal>
    </div>
</template>

<script>
import EditText from "./EditText.vue";
export default {
    components: { EditText },
    name: "TextPanel",
    data() {
        return {
            showFonts: false,
            selectedFont: null,
            editingText: null,
            deletingText: null,
        };
    },
    async created() {
        const fonts = await this.$store.dispatch(
            "clientEngravings/getFonts",
            !parseInt(this.settings.engravingAllFonts) &&
                this.settings.engravingSelectedFonts
        );
        if (fonts.length) {
            this.selectedFont = fonts[0];
        }
    },
    methods: {
        selectFont(font) {
            this.selectedFont = font;
            this.showFonts = false;
        },

        addText() {
            if (!this.selectedFont) {
                const notification = {
                    element: "error",
                    message: "Необходимо выбрать шрифт",
                };
                this.$store.dispatch("notification/add", notification, {
                    root: true,
                });
                return false;
            }
            this.$store.dispatch("clientOrder/addText", {
                font: this.selectedFont,
                position: {
                    x: 0,
                    y: 0,
                },
                align: this.aligns[0],
                price: parseFloat(this.settings.engravingPriceSymbol),
                size: (this.fontSizes &&
                    this.fontSizes.length &&
                    this.fontSizes[0]) || {
                    cost_coefficient: 1,
                    height: 1,
                    id: 1,
                },
                cost_coef: 1,
                cost: parseFloat(this.settings.engravingCostSymbol),
            });
        },
        deleteText() {
            try {
                this.$store.dispatch("clientOrder/removeText", {
                    face_id: this.activeFace.face_id,
                    text_id: this.deletingText.text_id,
                });
                this.deletingText = null;
            } catch (error) {
                const notification = {
                    page: "error",
                    message:
                        error.response &&
                        error.response.data &&
                        error.response.data.message,
                };
                this.$store.dispatch("notification/add", notification, {
                    root: true,
                });
            }
        },
    },
    computed: {
        settings() {
            return this.$store.state.settings.settings;
        },
        aligns() {
            const result = this.$tm("main.aligns");

            if (!result || !Array.isArray(result) || result.length === 0) {
                return [
                    { id: "left", name: "Слева" },
                    { id: "center", name: "По центру" },
                    { id: "right", name: "Справа" },
                ];
            }

            return result;
        },

        fontSizes() {
            if (this.settings.fontSizes) {
                return JSON.parse(this.settings.fontSizes);
            }
            return [];
        },
        fonts() {
            return this.$store.state.clientEngravings.fonts;
        },
        activeFace() {
            return this.$store.getters["clientOrder/activeFace"];
        },
    },
    watch: {
        fonts(fonts) {
            if (fonts && fonts.length) {
                let newStyle = document.createElement("style");
                for (const font of fonts) {
                    newStyle.appendChild(
                        document.createTextNode(
                            "\
      @font-face {\
          font-family: '" +
                                font.name +
                                "';\
          src: url('" +
                                font.file +
                                "');\
      }\
      "
                        )
                    );
                }
                document.head.appendChild(newStyle);
            }
        },
    },
};
</script>

<style scoped>
.text__item {
    display: flex;
    justify-content: space-between;
    column-gap: 10px;
    padding: 0 15px 15px 15px;
    margin-left: -15px;
    margin-right: -15px;
}
.text__item + .text__item {
    border-top: 1px solid #e5e7eb;
    padding-top: 15px;
}
.text__index_name {
    display: flex;
    align-items: center;
    column-gap: 10px;
}
.text__index {
    font-size: 17px;
}
.text__name {
    font-size: 12px;
    font-weight: 400;
}
.text__actions {
    display: flex;
    column-gap: 10px;
}
.text__actions button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 27px;
    height: 27px;
    padding: 4px;
    border-radius: 3px;
}
.text__actions button.button-edit {
    background-color: #25a24c;
}
.text__actions button.button-delete {
    border: 1px #d2e4e9 solid;
}
.button__add_text {
    display: grid;
    grid-template-columns: auto auto;
    height: 50px;
    background-color: #0da06f;
    color: #fff;
    padding: 6px 0;
    border-radius: 4px;
    align-items: center;
}
.button__add_text_t {
    font-size: 30px;
    font-weight: 100;
    line-height: 1;
    padding: 0 15px;
    border-right: 1px solid #28d199;
}
.button__add_text_label {
    font-style: 18px;
    padding: 0 30px;
}
</style>
